<div class="text-center col-md-8 col-md-offset-2">
    <h2 class="heading">We didn’t find any loans for your rating preferences</h2>
    <p>You can either continue to change preferences and keep looking for loans or go ahead and complete the
        investment.</p>
    <div class="bordered p-3">
        <h3 class="small-heading">Confirm your investment and let us automatically find loans for you</h3>
        <p>Your rating preferences are as follows:</p>
        <app-selected-preferences [preferredCategories]="portfolioCreationData.portfolioPreference">
        </app-selected-preferences>
        <p>New loans are listed on finzy everyday, we will allot these to your portfolio based on your rating
            preference.</p>
        <strong>
            <p>Loans are getting filled fast on finzy! See the loans funded by other investors <a [routerLink]="['/recently-filled-loans']">here.</a><p>
        </strong>
        <div>
            <button mat-flat-button class="primary" (click)="createPortfolio()" *ngIf="!shouldShowLoader">CONFIRM INVESTMENT
            </button>
            <mat-spinner [diameter]="35" class="m-auto" *ngIf="shouldShowLoader"></mat-spinner>
        </div>
        <p>
            In case you want to choose your own loans you can Switch to
            <a routerLink="" (click)="navigateToManualInvest()">manual invest</a> or you can
            <a [routerLink]="['/investordashboard']">invest later</a>.
        </p>
    </div>
    <p class="or">OR</p>
    <app-portfolio-preferences-picker [preferredCategories]="portfolioCreationData.portfolioPreference"
                                      (onPreferredCategoriesChanged)="onFindLoansClicked($event)"
                                      [isAlwaysExpanded]="true">
        <div heading>Update rating preferences and try again</div>
        <div expandedPreDescription>Increasing the rating categories may help finzyPRO+ find you more loans.</div>
        <div expandedPostDescription>Click on FIND LOANS to have finzyPRO+ algorithm find you loans based on your
            rating preference.</div>
        <div positiveButtonText>FIND LOANS</div>
    </app-portfolio-preferences-picker>
</div>
